import customaxios from ".";

export const directPayment = (data: any) => {
  return customaxios({
    method: "POST",
    url: `/payment/direct`,
    data,
  });
};

export const createPayment = (data: any) => {
  return customaxios({
    method: "POST",
    url: `/payment/create`,
    data,
  });
};

export const getUserCustomerStripeId = (data: any) => {
  return customaxios({
    method: "POST",
    url: "/user/stripe/customer-id",
    data,
  });
};
